export default __webpack_public_path__ + "static/media/serviços3e4.55ea3689.svg";